var App = App || {};

App.WidgetCompare = (function ($) {
    'use strict';

    function Init(widget) {
        EqualHeight(widget);
        $(window).on('resize', function () { EqualHeight(widget);});
        Overflow(widget);
    }

    function EqualHeight(widget) {

        const targetRow = widget.find(".table-row.columnheaders");
        const targetHeaders = targetRow.find(".table-cell--default").find(".table-cell__bg");

        let maxHeight = 0;
        targetHeaders.each(function () { maxHeight = Math.max(maxHeight, $(this).height()); });
        targetHeaders.removeAttr("style").height(maxHeight);
    }

    function Overflow(widget) {
        widget.ZagHorizontalOverflow({ arrowsPlacement: "afterbegin" });
    }

    return {
        Init: Init
    };

})(jQuery);